module.exports = __webpack_public_path__ + "static/media/kitchen.05d76540.jpg";